import React, { ReactNode } from 'react';

const EmptyLayout: React.FC<{ children: ReactNode }> = ({ children }) => {

  return (
    <div className="dark:bg-boxdark-2 dark:text-bodydark" style={{ backgroundImage: `url('/sideImage.png')`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
      {/* <!-- ===== Page Wrapper Start ===== --> */}
      <div className="flex h-screen overflow-hidden">

        {/* <!-- ===== Content Area Start ===== --> */}
        <div className="relative flex flex-1 flex-col overflow-y-auto overflow-x-hidden justify-center">

          {/* <!-- ===== Main Content Start ===== --> */}
          <main>
            <div className="mx-auto max-w-screen-2xl p-4 md:p-6 2xl:p-10 bg-white/80 dark:bg-boxdark/80">
              {children}
            </div>
          </main>
          {/* <!-- ===== Main Content End ===== --> */}
        </div>
        {/* <!-- ===== Content Area End ===== --> */}
      </div>
      {/* <!-- ===== Page Wrapper End ===== --> */}
    </div>
  );
};

export default EmptyLayout;
